/**
 * Media Player device action preparations.
 * Duplicated from Scenes for Flow independence.
 */

import type { DeviceActionContext, PreparedDeviceAction } from '../types';

export const prepareMediaPlayerAction = (context: DeviceActionContext): PreparedDeviceAction => {
	const { hexToDecimal, actions } = context;

	const action: PreparedDeviceAction = {
		_gui_purpose: 'action',
		r: 'dev:' + hexToDecimal + ':' + actions[0].name,
	};

	const actionValue = actions[0]?.value;
	const set = {
		...(typeof actionValue === 'object' ? actionValue : {}),
		_isdata: true,
	};

	action.set = set;
	return action;
};
